import React from 'react';

import clsx from 'clsx';

import { Grid, Stack, makeStyles } from '@gogame/components';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'auto',
    padding: theme.spacing(2),
  },
  disableGutters: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  dense: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const TilesList = ({
  tileComponent,
  tileProps,
  rows,
  columns,
  width,
  height,
  disableGutters,
  dense,
}) => {
  const classes = useStyles({});

  return (
    <Stack
      className={clsx(classes.root, {
        [classes.disableGutters]: disableGutters,
        [classes.dense]: dense,
      })}
      width={width}
      height={height}
    >
      <Grid container spacing={2} columns={columns}>
        {rows?.map((tile) => (
          <Grid key={tile?.id} item xs={1}>
            {React.createElement(tileComponent, {
              data: tile,
              ...tileProps,
            })}
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default TilesList;
